import { ThemeEvents } from '@theme/events';

class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price.
   * @param {Event} event - The variant update event.
   */
  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newPrice = event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
    const currentPrice = this.querySelector('[ref="priceContainer"]');

    if (!newPrice || !currentPrice) return;

    if (currentPrice.innerHTML !== newPrice.innerHTML) {
      currentPrice.replaceWith(newPrice);
    } else {
      const minor = newPrice.getAttribute('data-price-minor');
      const cur = newPrice.getAttribute('data-currency');
      if (minor != null) currentPrice.setAttribute('data-price-minor', minor);
      if (cur != null) currentPrice.setAttribute('data-currency', cur);
      const cmp = newPrice.getAttribute('data-compare-minor');
      if (cmp != null && cmp !== '') {
        currentPrice.setAttribute('data-compare-minor', cmp);
      } else {
        currentPrice.removeAttribute('data-compare-minor');
      }
    }

    document.dispatchEvent(new CustomEvent('theme:convert-prices'));
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
